import React from "react";
import { Link } from "gatsby";

import { surveyHeader, surveyLogo, alerts, saveStyleButton } from "./headerSurvey.module.scss";

import Logo from "../../atoms/logo";
import AlertList from "../alert-list";
import ButtonIcon from "../../molecules/button-icon";
import { useGeneratorHeaderSaveConfig } from "../../../contexts/generator-header-save.context";

interface IHeaderSurveyProps {
    className?: string;
}

const HeaderSurvey: React.FC<IHeaderSurveyProps> = ({ className }) => {
    const saveConfig = useGeneratorHeaderSaveConfig();
    const showSaveStyle =
        saveConfig?.visible && typeof saveConfig.onSave === "function";

    return (
        <header className={`${surveyHeader} ${className}`}>
            <Link to={"/"}>
                <Logo className={surveyLogo} color={"black"} type={"responsive"} />
            </Link>
            {showSaveStyle && (
                <ButtonIcon
                    withLink={false}
                    onClick={saveConfig.onSave}
                    htmlType="button"
                    className={saveStyleButton}
                    text={"Zapisz styl"}
                />
            )}
            <AlertList className={alerts} />
        </header>
    );
};
export default HeaderSurvey;
